/**
 * @description Module recherche de l'en-tête
 */

/* global ModuloTS $toggle */

(() => {
	// VARS
	const root = document.querySelector('[data-js-header-search-root]');

	const $ = {
		toggle: 'data-js-header-search-toggle',
		content: 'views-exposed-form',
	};

	// FONCTIONS
	const style = () => {
		const form = root.querySelector(`.${$.content}`);
		const inputs = form.querySelectorAll('input[type="text"]');
		const buttons = form.querySelectorAll('input[type="submit"]');

		form.classList.add('module', 'shadow');

		inputs.forEach((element) => {
			element.classList.add('form-control');
			element.setAttribute(
				'placeholder',
				ModuloTS['What are you looking for ?']
			);
		});

		buttons.forEach((element) => {
			element.classList.add('btn', 'btn-primary');
		});
	};

	const toggle = () => {
		document
			.querySelector('.views-exposed-form')
			.insertAdjacentHTML(
				'afterend',
				'<div class="search-overlay"></div>'
			);

		root.querySelector(`[${$.toggle}]`).addEventListener('click', () => {
			const el = root.querySelector(`.${$.content}`);
			el.classList.toggle('views-exposed-form--open');
			document
				.querySelector('.header__branding')
				.classList.toggle('search-img--active');

			document
				.querySelector('.search-overlay')
				.classList.toggle('search-overlay--active');
			document.querySelector('body').classList.toggle('overflow-h');

			if (
				root.querySelector(`[${$.toggle}] span`).innerText ===
				'Rechercher'
			) {
				root.querySelector(`[${$.toggle}] span`).innerText = 'Fermer';
				root.querySelector(`[${$.toggle}]`).setAttribute(
					'data-icon',
					'cross'
				);
				root.querySelector(`[${$.toggle}]`).setAttribute(
					'aria-expanded',
					true
				);
			} else {
				root.querySelector(`[${$.toggle}] span`).innerText =
					'Rechercher';
				root.querySelector(`[${$.toggle}]`).setAttribute(
					'data-icon',
					'search'
				);
				root.querySelector(`[${$.toggle}]`).setAttribute(
					'aria-expanded',
					false
				);
			}
			$toggle(el, 'block');
		});
	};

	// GO 🚀
	const init = () => {
		if (document.body.contains(root)) {
			style();
			toggle();
		}
	};

	init();
})();
